import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { HeaderAggDataResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useHeaderAggData = () => {
  return useQuery<any, AxiosError<any>, HeaderAggDataResponse>(
    ["header", "aggData"],
    () =>
      axiosClient
        .get<HeaderAggDataResponse>(`/reports/headerAggData`)
        .then(({ data }) => data),
    {
      staleTime: Infinity,
    }
  );
};
